import React from 'react';
import { IconProps } from '../../../DefaultIcon';

export function ClientStatusIcon({ className }: IconProps) {
  return (
    <svg
      width="78"
      height="75"
      viewBox="0 0 78 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_812_894)">
        <path
          d="M53.1797 58.5737H24.8203V70.008H53.1797V58.5737Z"
          fill="#EAEDF8"
        />
        <path
          d="M73.7296 60.7132H4.24682C1.91107 60.7132 0 58.7876 0 56.4342V4.27892C0 1.92551 1.91107 0 4.24682 0H73.7296C76.0653 0 77.9764 1.92551 77.9764 4.27892V56.4342C77.9764 58.7876 76.0653 60.7132 73.7296 60.7132Z"
          fill="#EAEDF8"
        />
        <path
          d="M64.882 74.9999H13.1179C11.7495 74.9999 10.6406 73.8826 10.6406 72.5038C10.6406 71.1251 11.7495 70.0078 13.1179 70.0078H64.882C66.2504 70.0078 67.3593 71.1251 67.3593 72.5038C67.3593 73.8826 66.2504 74.9999 64.882 74.9999Z"
          fill="#EAEDF8"
        />
        <path
          d="M70.5444 55.3644H7.45544C6.27577 55.3644 5.33203 54.4135 5.33203 53.2249V7.51178C5.33203 6.32319 6.27577 5.37231 7.45544 5.37231H70.568C71.7476 5.37231 72.6914 6.32319 72.6914 7.51178V53.2249C72.6914 54.4135 71.7476 55.3644 70.568 55.3644"
          fill="white"
        />
        <path
          d="M38.7636 31.0697H7.80898C7.62023 31.0697 7.45508 30.7607 7.45508 30.4041C7.45508 30.0476 7.62023 29.7385 7.80898 29.7385H38.7636C38.9524 29.7385 39.1175 30.0476 39.1175 30.4041C39.1175 30.7607 38.9524 31.0697 38.7636 31.0697Z"
          fill="#00C4B3"
        />
        <path
          d="M38.9998 53.5816C38.5987 53.5816 38.292 53.2725 38.292 52.8684V7.86843C38.292 7.46431 38.6223 7.15527 38.9998 7.15527C39.3773 7.15527 39.7076 7.48808 39.7076 7.86843V52.8684C39.7076 53.2725 39.3773 53.5816 38.9998 53.5816Z"
          fill="#00C4B3"
        />
        <path
          d="M21.9895 17.8525C17.2944 17.8525 13.4486 21.3708 12.8588 25.9349C12.7644 26.5768 13.2835 27.1473 13.9205 27.1473H30.082C30.719 27.1473 31.2145 26.5768 31.1437 25.9349C30.5539 21.3708 26.6846 17.8525 22.013 17.8525"
          fill="#00C4B3"
        />
        <path
          d="M29.0674 12.8605C29.0674 16.8067 25.8823 20.0159 21.9657 20.0159C18.0492 20.0159 14.8877 16.8067 14.8877 12.8605C14.8877 8.91442 18.0728 5.729 21.9657 5.729C25.8587 5.729 29.0674 8.9382 29.0674 12.8605Z"
          fill="white"
        />
        <path
          d="M26.9434 12.8605C26.9434 15.618 24.7256 17.8526 21.9888 17.8526C19.252 17.8526 17.0342 15.618 17.0342 12.8605C17.0342 10.103 19.252 7.86841 21.9888 7.86841C24.7256 7.86841 26.9434 10.103 26.9434 12.8605Z"
          fill="#00C4B3"
        />
        <path
          d="M21.9895 43.217C17.2944 43.217 13.4486 46.7353 12.8588 51.2994C12.7644 51.9413 13.2835 52.5118 13.9205 52.5118H30.082C30.719 52.5118 31.2145 51.9413 31.1437 51.2994C30.5539 46.7353 26.6846 43.217 22.013 43.217"
          fill="#00416B"
        />
        <path
          d="M29.0674 38.2251C29.0674 42.1713 25.8823 45.3804 21.9657 45.3804C18.0492 45.3804 14.8877 42.1713 14.8877 38.2251C14.8877 34.279 18.0728 31.0698 21.9657 31.0698C25.8587 31.0698 29.0674 34.279 29.0674 38.2251Z"
          fill="white"
        />
        <path
          d="M26.9434 38.225C26.9434 40.9825 24.7256 43.2171 21.9888 43.2171C19.252 43.2171 17.0342 40.9825 17.0342 38.225C17.0342 35.4675 19.252 33.2329 21.9888 33.2329C24.7256 33.2329 26.9434 35.4675 26.9434 38.225Z"
          fill="#00416B"
        />
        <path
          d="M70.0022 19.1839L65.4959 17.2109C65.0948 17.0445 64.6229 17.1158 64.3162 17.4486L57.4269 24.4375C57.0966 24.7941 56.5539 24.8654 56.1293 24.6039L51.6937 22.0128C51.269 21.7513 50.7028 21.8464 50.3724 22.2267L42.6338 30.9985V52.3218H70.0258V19.1839H70.0022Z"
          fill="#EAEDF8"
        />
        <path
          d="M70.0014 33.4945L65.5658 31.2599C65.1175 31.046 64.5749 31.1649 64.2682 31.5452L57.025 40.4596C56.6947 40.8638 56.152 40.9588 55.7038 40.7211L50.7019 38.0111C50.2773 37.7734 49.7818 37.8685 49.4515 38.2013L42.6094 45.1664V52.3218H70.0014V33.4945Z"
          fill="#00C4B3"
        />
        <path
          d="M60.0458 40.412C60.0458 42.385 58.4651 43.9777 56.5068 43.9777C54.5485 43.9777 52.9678 42.385 52.9678 40.412C52.9678 38.4389 54.5485 36.8462 56.5068 36.8462C58.4651 36.8462 60.0458 38.4389 60.0458 40.412Z"
          fill="#FAFBFD"
        />
        <path
          d="M68.3739 16.9017C68.3739 18.8748 66.7932 20.4675 64.8349 20.4675C62.8767 20.4675 61.2959 18.8748 61.2959 16.9017C61.2959 14.9286 62.8767 13.3359 64.8349 13.3359C66.7932 13.3359 68.3739 14.9286 68.3739 16.9017Z"
          fill="#00416B"
        />
        <path
          d="M58.6296 40.4122C58.6296 41.6008 57.6859 42.5516 56.5062 42.5516C55.3266 42.5516 54.3828 41.6008 54.3828 40.4122C54.3828 39.2236 55.3266 38.2727 56.5062 38.2727C57.6859 38.2727 58.6296 39.2236 58.6296 40.4122Z"
          fill="#00416B"
        />
        <path
          d="M66.9587 16.9017C66.9587 18.0903 66.015 19.0411 64.8353 19.0411C63.6557 19.0411 62.7119 18.0903 62.7119 16.9017C62.7119 15.7131 63.6557 14.7622 64.8353 14.7622C66.015 14.7622 66.9587 15.7131 66.9587 16.9017Z"
          fill="#00C4B3"
        />
        <path
          d="M57.2144 43.217H55.7988V52.3216H57.2144V43.217Z"
          fill="#FAFBFD"
        />
        <path
          d="M65.5426 19.7068H64.127V52.3217H65.5426V19.7068Z"
          fill="#00416B"
        />
        <path
          d="M72.9273 36.6799H71.5117V52.298H72.9273V36.6799Z"
          fill="#FAFBFD"
        />
        <path
          d="M71.5356 53.035H42.6336C42.2325 53.035 41.9258 52.726 41.9258 52.3218V9.43752C41.9258 9.0334 42.2325 8.72437 42.6336 8.72437C43.0347 8.72437 43.3414 9.0334 43.3414 9.43752V51.5849H71.5356C71.9367 51.5849 72.2434 51.8939 72.2434 52.2981C72.2434 52.7022 71.9131 53.0112 71.5356 53.0112"
          fill="#00416B"
        />
        <path
          d="M44.757 45.8797H42.6336C42.2325 45.8797 41.9258 45.5706 41.9258 45.1665C41.9258 44.7624 42.2561 44.4534 42.6336 44.4534H44.757C45.1581 44.4534 45.4648 44.7862 45.4648 45.1665C45.4648 45.5469 45.1345 45.8797 44.757 45.8797Z"
          fill="#00416B"
        />
        <path
          d="M44.757 38.7481H42.6336C42.2325 38.7481 41.9258 38.4391 41.9258 38.0349C41.9258 37.6308 42.2561 37.3218 42.6336 37.3218H44.757C45.1581 37.3218 45.4648 37.6308 45.4648 38.0349C45.4648 38.4391 45.1345 38.7481 44.757 38.7481Z"
          fill="#00416B"
        />
        <path
          d="M44.757 31.5928H42.6336C42.2325 31.5928 41.9258 31.2838 41.9258 30.8797C41.9258 30.4755 42.2561 30.1665 42.6336 30.1665H44.757C45.1581 30.1665 45.4648 30.4993 45.4648 30.8797C45.4648 31.26 45.1345 31.5928 44.757 31.5928Z"
          fill="#00416B"
        />
        <path
          d="M44.757 24.4373H42.6336C42.2325 24.4373 41.9258 24.1283 41.9258 23.7241C41.9258 23.32 42.2561 23.011 42.6336 23.011H44.757C45.1581 23.011 45.4648 23.3438 45.4648 23.7241C45.4648 24.1045 45.1345 24.4373 44.757 24.4373Z"
          fill="#00416B"
        />
        <path
          d="M44.757 17.3059H42.6336C42.2325 17.3059 41.9258 16.9969 41.9258 16.5928C41.9258 16.1887 42.2561 15.8796 42.6336 15.8796H44.757C45.1581 15.8796 45.4648 16.1887 45.4648 16.5928C45.4648 16.9969 45.1345 17.3059 44.757 17.3059Z"
          fill="#00416B"
        />
        <path
          d="M44.757 10.1507H42.6336C42.2325 10.1507 41.9258 9.84164 41.9258 9.43752C41.9258 9.0334 42.2561 8.72437 42.6336 8.72437H44.757C45.1581 8.72437 45.4648 9.05717 45.4648 9.43752C45.4648 9.81787 45.1345 10.1507 44.757 10.1507Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_812_894">
          <rect width="78" height="75" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
